// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oyCV","colBig":"styles_colBig__ZuGs8","colSmall":"styles_colSmall__1iRCg","shopifyNameWrapper":"styles_shopifyNameWrapper__1bLdK"};